import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-progress-stepper',
	templateUrl: './progress-stepper.component.html',
	styleUrls: ['./progress-stepper.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ProgressStepperComponent {
	@Input() steps: any[];

	@Input() activeStep: number;

	isCurrentStep(targetStep: number) {
		return this.activeStep === targetStep;
	}

	isFinishedStep(targetStep: number) {
		return this.activeStep > targetStep;
	}
}
